import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthenticationService, VersionCheckService } from '../../_services';


@Component({
  templateUrl: './login.component.html',
  styleUrls: ['../auth.component.less']
},
)
export class LoginComponent implements OnInit, OnDestroy {
  disCap: boolean;
  form: UntypedFormGroup;
  loading = false;
  returnUrl: string;
  passwordVisible = false;
  isCaptchaVerified = false;
  env = environment;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private authService: AuthenticationService,
    private vcs: VersionCheckService,
  ) {
    // redirect to home if already logged in
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      captcha: [null, this.env.captcha ? [Validators.required] : []],
    });
  }

  ngOnInit(): void {
    // get return url from route parameters
    const returnUrlParam = this.route.snapshot.queryParams['returnUrl'];
    this.disCap = this.route.snapshot.params['disCap'] === '6a9b49a2-07f9-456d-b174-f20c089d90ae';
    if (this.disCap) {
      this.form.controls.captcha.clearValidators();
    }
    if (returnUrlParam && !returnUrlParam.includes('returnUrl')) {
      this.returnUrl = returnUrlParam;
    }
    this.vcs.refreshPageIfNeeded();
  }

  // convenience getter for easy access to form fields
  // eslint-disable-next-line @typescript-eslint/member-ordering
  get f(): { [p: string]: AbstractControl } {
    return this.form.controls;
  }

  onSubmit(): void {
    if (this.form.invalid || (!this.disCap && this.env.captcha && !this.isCaptchaVerified)) {
      this.form.markAsDirty();
      this.form.updateValueAndValidity();
      return;
    }
    this.login();
  }

  login(): void {
    this.loading = true;
    this.authService.login(this.f.email.value, this.f.password.value, this.returnUrl)
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => this.loading = false),
      ).subscribe();
  }

  captchaResolved(isResolved: boolean): void {
    this.isCaptchaVerified = isResolved;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

